import { createSelector } from '@ngrx/store'

import { AttachmentState, selectAll } from './attachment.reducer'

export const attachmentState = (state): AttachmentState => state.attachment

export const attachments = createSelector(attachmentState, selectAll)
export const hasAttachment = createSelector(attachmentState, attachment => attachment.ids.length > 0)
